import { SunIcon } from '@heroicons/react/24/outline';
import { DayData, MealOption } from '../../types';
import { JSX } from 'react';


interface MealPreferenceCheckboxProps {
  day: DayData;
  meal: MealOption;
  selectedMeals: Record<string, string[]>;
  handleMealSelect: (dayId: string, mealName: string) => void;
  mealIcons: { [key: string]: JSX.Element };
}

const MealPreferenceCheckbox = ({
  day,
  meal,
  selectedMeals,
  handleMealSelect,
  mealIcons
}: MealPreferenceCheckboxProps) => {
  const mealPassed = new Date() > day.date;

  return (
    <label className={`flex items-center gap-3 p-3 rounded-lg border ${!mealPassed && selectedMeals[day.date.toISOString()]?.includes(meal.name)
        ? 'border-blue-600 bg-blue-50'
        : 'border-gray-200'
      } ${mealPassed ? 'opacity-50 cursor-not-allowed' : 'hover:border-blue-400'}`}>
      <input
        type="checkbox"
        checked={selectedMeals[day.date.toISOString()]?.includes(meal.name) || false}
        onChange={() => !mealPassed && handleMealSelect(day.date.toISOString(), meal.name)}
        className="form-checkbox h-5 w-5 text-blue-600 rounded border-gray-300"
        disabled={mealPassed}
      />
      <div className="flex items-center gap-2">
        {mealIcons[meal.name.toLowerCase()] || <SunIcon className="w-5 h-5 text-gray-400" />}
        <span className="font-medium text-gray-700">{meal.name}</span>
      </div>
    </label>
  );
};
export default MealPreferenceCheckbox